// angular import
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';

// project import
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { RequestService } from 'src/app/services/http-service.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, SharedModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export default class LoginComponent {
  // public props
  hide = true;
  email = new FormControl('', [Validators.required, Validators.email]);
  Email = '';
  password = '';

  constructor(public http:RequestService, public router:Router){

  }

  // public method
  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter an email';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  login() {

    if (this.Email != "" && this.password != "") {
      let user = {
        'email': this.Email,
        'password': this.password,
      };
      this.http.post('auth/login/administrator', user).then((res) => {
        console.log(res);
        localStorage.setItem("hotel_user", JSON.stringify(res.administrator));
        localStorage.setItem("hotel_token", res.token);        
        this.router.navigate(["/hotel"]);  
      }, error => {

      });
    } else {
      alert("Füllen Sie alle Felder aus!");
    }
  }
}
